/* -------------------------------------------------------------------------- */
/*                                  Scroller                                  */
/* -------------------------------------------------------------------------- */

var debounce=function debounce(fn) {
    var frame;

    return function () {
        for (var _len=arguments.length, params=new Array(_len), _key=0; _key < _len; _key++) {
            params[_key]=arguments[_key];
        }

        if (frame) {
            cancelAnimationFrame(frame);
        }

        frame=requestAnimationFrame(function () {
                fn.apply(void 0, params);
            }

        );
    };
};

var storeScroll = function storeScroll() {
    document.documentElement.dataset.scroll = window.scrollY;
};

document.addEventListener('scroll', debounce(storeScroll), {
        passive: true
    }

);
storeScroll();

/* -------------------------------------------------------------------------- */
/*                             Scroll for homepage                            */
/* -------------------------------------------------------------------------- */
var button = document.getElementById('scroll-down');

if (button) {
    button.addEventListener('click', function() {
            const sections = document.querySelectorAll('section');

            for (const section of sections) {
                const rect = section.getBoundingClientRect();
                if (rect.top >= 7 * parseFloat(getComputedStyle(section).fontSize)) {
                    window.scrollTo({
                        top: window.scrollY + rect.top - 7 * parseFloat(getComputedStyle(section).fontSize),
                        behavior: 'smooth'
                    });
                    break;
                }
            }
        });
}

/* -------------------------------------------------------------------------- */
/*              Hide button when you reach the bottom of the page             */
/* -------------------------------------------------------------------------- */
window.addEventListener('scroll', function() {
      let fixedMobileBar = document.getElementById("quick-action");
      if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 100 && fixedMobileBar) {
        fixedMobileBar.classList.add("sticky-button--hidden");
      } else if (window.scrollY > 1) {
        fixedMobileBar.classList.remove("sticky-button--hidden");
      }
    });